import ReactDOM from "react-dom";
import Button, { OutlineButton } from "./General/Button";
import Modal from "./General/Modal";
export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  children,
  buttonCancelText,
  buttonConfirmText,
  title,
  isPending = false,
}) => {
  return ReactDOM.createPortal(
    <Modal title={title} isOpen={isOpen} onClose={onClose}>
      {children}
      <div className="flex justify-end mt-4">
        <OutlineButton
          className="mx-2"
          onClick={onClose}
          text={buttonCancelText}
        />
        <Button className="mx-2" onClick={onConfirm} text={buttonConfirmText} isPending={isPending} />
      </div>
    </Modal>,
    document.body
  );
};
